import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
//import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Componentes
import PersonaACargo from "./personaACargo";

// API
import ProcesosApi from "api/procesosApi";

const PersonasACargo = ({ procesoId, identificador, setError }) => {
  const [personas, setPersonas] = useState([]);
  const [loading, setLoading] = useState(true);

  const cargarPersonas = async () => {
    try {
      const respPersonas = await ProcesosApi.obtenerPersonasCargo(procesoId);
      if (respPersonas.data) {
        setPersonas(respPersonas.data);
      }
    } catch (error) {
      console.error("Error cargando las Personas a Cargo:", error);
      setError(obtenerMensajeError(error, "Error al cargar las Personas a Cargo"));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await cargarPersonas();
      } catch (error) {
        console.error("Error cargando datos:", error);
        setError(obtenerMensajeError(error, "Error al cargar los datos"));
      } finally {
        setLoading(false);
      }
    };
    if (procesoId) {
      fetchData();
    }
  }, [procesoId]);

  if (loading) {
    return (
      <SuiBox display="flex" justifyContent="center" p={3}>
        <SuiTypography variant="button" color="text" fontWeight="regular">
          Cargando archivos de las personas a cargo...
        </SuiTypography>
      </SuiBox>
    );
  }

  return (
    <SuiBox p={2}>
      <Grid container>
        {personas.map((persona) => (
          <Grid item xs={12} md={6} key={persona.id || `temp-${persona.nombre_completo}`}>
            <PersonaACargo
              persona={persona}
              procesoId={procesoId}
              identificador={identificador}
              setError={setError}
            />
          </Grid>
        ))}
      </Grid>
    </SuiBox>
  );
};

PersonasACargo.propTypes = {
  procesoId: PropTypes.number.isRequired,
  identificador: PropTypes.string,
  setError: PropTypes.func.isRequired,
};

export default PersonasACargo;
